export default __webpack_public_path__ + "blue-arrow-icon.ee3f5fc29aadea2e69b5.png";